const auth = ['admin', 'manager', 'worker']
const admin = ['admin']
const config = {
  name: '天码CE',
  copyright: '版权所有 ©湖北天码科技有限责任公司',
  BASE_URL: 'https://junesunray.com/ce',
  // BASE_URL: 'http://8.218.19.35/ce',
  // BASE_URL: 'http://127.0.0.1/ce',
  REQUEST_TIMEOUT: 5 * 60 * 1000,
  auth: auth,
  menus: [
    { id: 'service', name: '当前工程', icon: 'crosshairs', auth: auth },
    {
      name: '工程管理', icon: 'database', childs: [
        { id: 'service', name: '当前工程', auth: auth },
        { id: 'project', name: '工程列表', auth: auth },
        { id: 'project', name: '退出工程', auth: auth }
      ], auth: auth
    },
    {
      name: '源码&部署', icon: 'hdd', childs: [
        // { id: 'frame', name: '框架管理', auth: admin },
        { id: 'node', name: '项目部署', auth: auth },
        { id: 'frame', name: '源码生成', auth: auth },
      ], auth: auth
    },
    {
      name: '工具', icon: 'store', childs: [
        { id: 'api', name: 'API文档', auth: auth },
        { id: 'dbms', name: '数据库管理', auth: auth },
        { id: 'server', name: '功能管理', auth: auth },
        { id: 'proxy', name: '流代理转接', auth: auth },
        { id: 'utils', name: 'SQL执行工具', auth: auth },
        { id: 'ai', name: 'AI工具', auth: auth },
      ], auth: auth
    },
    {
      name: '组件', icon: 'store', childs: [
        // { id: 'method', name: '模块组件', icon: 'store', auth: auth },
        // { id: 'method', name: '前端组件', icon: 'shopping-cart', auth: auth },
        { id: 'method', name: '后端组件', icon: 'shopping-cart', auth: auth },
      ], auth: admin
    },
    { id: 'project', name: '设置', icon: 'bell', auth: auth },
    { id: 'project', name: '教程文档', icon: 'exclamation-triangle', auth: auth },
  ],
  defaultPage: 'home',
  layouts: {
    service: () => import('@/layout/ServiceWorkLayout'),
    web: () => import('@/layout/WebWorkLayout'),
    pc: () => import('@/layout/PCWorkLayout'),
    manage: () => import('@/layout/ManageStyle'),
    empty: () => import('@/layout/EmptyLayout'),
    default: () => import('@/layout/ManageStyle')
  },
  pages: {
    404: {
      path: '/404',
      layout: 'empty',
      component: () => import('@/views/public/404'),
      auth: auth
    },
    405: {
      path: '/405',
      layout: 'empty',
      component: () => import('@/views/public/405'),
      auth: auth
    },
    login: {
      path: '/login',
      layout: 'empty',
      component: () => import('@/views/login/index'),
      auth: auth
    },
    register: {
      path: '/register',
      layout: 'empty',
      component: () => import('@/views/login/register'),
      auth: auth
    },

    
    home: {
      path: '/home',
      layout: 'empty',
      component: () => import('@/views/index/home'),
      auth: auth
    },
    video: {
      path: '/video',
      layout: 'empty',
      component: () => import('@/views/video/index'),
      auth: auth
    },

    group: {
      path: '/group',
      layout: 'empty',
      component: () => import('@/views/group/index'),
      auth: auth
    },
    project: {
      path: '/project',
      component: () => import('@/views/project/index'),
      auth: auth
    },
    // 微服务
    service: {
      path: '/service',
      component: () => import('@/views/service/service'),
      layout: 'service',
      auth: auth
    },
    serviceConfig: {
      path: '/serviceConfig',
      component: () => import('@/views/service/config'),
      layout: 'service',
      auth: auth
    },
    serviceData: {
      path: '/serviceData',
      component: () => import('@/views/service/data'),
      layout: 'service',
      auth: auth
    },
    serviceApi: {
      path: '/serviceApi',
      component: () => import('@/views/service/api'),
      layout: 'service',
      auth: auth
    },
    serviceTask: {
      path: '/serviceTask',
      component: () => import('@/views/service/task'),
      layout: 'service',
      auth: auth
    },
    serviceCode: {
      path: '/serviceCode',
      component: () => import('@/views/service/code'),
      layout: 'service',
      auth: auth
    },
    // 网站
    web: {
      path: '/web',
      component: () => import('@/views/web/web'),
      layout: 'web',
      auth: auth
    },
    webConfig: {
      path: '/webConfig',
      component: () => import('@/views/web/config'),
      layout: 'web',
      auth: auth
    },
    webTask: {
      path: '/webTask',
      component: () => import('@/views/web/task'),
      layout: 'web',
      auth: auth
    },
    webCode: {
      path: '/webCode',
      component: () => import('@/views/web/code'),
      layout: 'web',
      auth: auth
    },
    webAI: {
      path: '/webAI',
      component: () => import('@/views/web/ai'),
      layout: 'web',
      auth: auth
    },
    // PC
    pc: {
      path: '/pc',
      component: () => import('@/views/pc/pc'),
      layout: 'pc',
      auth: auth
    },
    pcService: {
      path: '/pcService',
      component: () => import('@/views/pc/service'),
      layout: 'pc',
      auth: auth
    },
    pcConfig: {
      path: '/pcConfig',
      component: () => import('@/views/pc/config'),
      layout: 'pc',
      auth: auth
    },
    pcTask: {
      path: '/pcTask',
      component: () => import('@/views/pc/task'),
      layout: 'pc',
      auth: auth
    },
    pcCode: {
      path: '/pcCode',
      component: () => import('@/views/pc/code'),
      layout: 'pc',
      auth: auth
    },

    methodEdit: {
      path: '/method/edit',
      component: () => import('@/views/method/edit'),
      layout: 'empty',
      auth: auth
    },
    frame: {
      path: '/frame',
      component: () => import('@/views/frame/index'),
      auth: auth
    },
    flow: {
      path: '/flow',
      component: () => import('@/views/flow/execute'),
      layout: 'empty',
      auth: auth
    },
    frameFile: {
      path: '/frame/file',
      component: () => import('@/views/frame/file'),
      auth: auth
    },
    frameFileDetail: {
      path: '/frame/fileDetail',
      component: () => import('@/views/frame/fileDetail'),
      auth: auth
    },
    api: {
      path: '/api',
      component: () => import('@/views/api/index'),
      auth: auth
    },
    dbms: {
      path: '/dbms',
      component: () => import('@/views/dbms/index'),
      auth: auth
    },
    server: {
      path: '/server',
      component: () => import('@/views/server/index'),
      auth: auth
    },
    contract: {
      path: '/contract',
      component: () => import('@/views/utils/contract'),
      auth: auth
    },
    utils: {
      path: '/utilsIndex',
      component: () => import('@/views/utils/index'),
      auth: auth
    },
    proxy: {
      path: '/proxy',
      component: () => import('@/views/proxy/index'),
      auth: auth
    },
    node: {
      path: '/node',
      component: () => import('@/views/node/index'),
      layout: 'empty',
      auth: auth
    },
    deploy: {
      path: '/deploy',
      component: () => import('@/views/node/deploy'),
      layout: 'empty',
      auth: auth
    },
    ai: {
      path: '/ai',
      component: () => import('@/views/ai/index'),
      auth: auth
    },
    GptForInventionPatent: {
      path: '/ai/GptForInventionPatent',
      component: () => import('@/views/ai/GptForInventionPatent'),
      auth: auth
    }
  }
}

export default config
